(() => {
  const submitButtonId = (sectionId) => `ProductSubmitButton-${sectionId}`;

  const copyVariantSubmitLabel = (event) => {
    const sectionId = event?.data?.sectionId;
    const sourceDocument = event?.data?.html;
    if (!sectionId || !sourceDocument) return;

    const sourceButton = sourceDocument.getElementById(submitButtonId(sectionId));
    const destinationButton = document.getElementById(submitButtonId(sectionId));
    const sourceLabel = sourceButton?.querySelector('[data-ark-submit-label]');
    const destinationLabel = destinationButton?.querySelector('[data-ark-submit-label]');

    if (sourceLabel && destinationLabel) {
      destinationLabel.textContent = sourceLabel.textContent.trim();
    }
  };

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.variantChange
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, copyVariantSubmitLabel);
  }

  class ArkFreeShippingMeter extends HTMLElement {
    connectedCallback() {
      this.thresholdCents = Number(this.dataset.thresholdCents);
      this.currency = this.dataset.currency || 'USD';
      this.messageElement = this.querySelector('[data-ark-shipping-message]');
      this.progressbarElement = this.querySelector('[data-ark-shipping-progressbar]');
      this.progressElement = this.querySelector('[data-ark-shipping-progress]');

      this.update(Number(this.dataset.initialTotalCents) || 0);

      if (
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData } = {}) => {
          const reportedTotal = Number(cartData?.total_price);
          if (Number.isFinite(reportedTotal)) {
            this.update(reportedTotal);
          } else {
            this.refreshFromCart();
          }
        });
      }
    }

    disconnectedCallback() {
      this.cartUpdateUnsubscriber?.();
      this.refreshController?.abort();
    }

    async refreshFromCart() {
      this.refreshController?.abort();
      this.refreshController = new AbortController();

      const cartPath = window.routes?.cart_url || '/cart';
      try {
        const response = await fetch(`${cartPath}.js`, {
          headers: { Accept: 'application/json' },
          signal: this.refreshController.signal,
        });
        if (!response.ok) return;

        const cartData = await response.json();
        if (this.isConnected && Number.isFinite(Number(cartData.total_price))) {
          this.update(Number(cartData.total_price));
        }
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      }
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: this.currency,
      }).format(cents / 100);
    }

    update(cartTotalCents) {
      if (!Number.isFinite(this.thresholdCents) || this.thresholdCents <= 0) return;

      const safeTotal = Math.max(0, Number(cartTotalCents) || 0);
      const remaining = Math.max(0, this.thresholdCents - safeTotal);
      const progress = Math.min(100, (safeTotal / this.thresholdCents) * 100);

      if (this.messageElement) {
        this.messageElement.textContent =
          remaining > 0
            ? `Add ${this.formatMoney(remaining)} more to qualify for free shipping.`
            : 'Free shipping unlocked.';
      }

      if (this.progressElement) {
        this.progressElement.style.setProperty('--ark-shipping-progress', `${progress}%`);
      }

      if (this.progressbarElement) {
        this.progressbarElement.setAttribute('aria-valuenow', String(Math.min(safeTotal, this.thresholdCents) / 100));
      }
    }
  }

  if (!customElements.get('ark-free-shipping-meter')) {
    customElements.define('ark-free-shipping-meter', ArkFreeShippingMeter);
  }
})();
